import {
  Button,
  CloseButton,
  Dialog,
  For,
  HStack,
  Portal,
  Flex,
  Box,
  Text,
  Modal,
} from "@chakra-ui/react";
import OnePDFDropzone from "./OnePdfDropzone";
const UploadPdfModal = ({ isOpen, setIsOpen, handleFileChange }) => {
  return (
    <Dialog.Root size={"md"} open={isOpen}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Upload PDF</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Flex height="100%" align="center" justify="center">
                <Box
                 
                  display="flex"
                  flexDirection="column"
                  gap={10}
                  alignItems="center"
                  justifyContent="center"
                  p={6}
                >
                  <Text color="gray.500" fontSize="sm" textAlign="center">
                    Drag and drop your PDF file here or click to select.
                  </Text>
                  <Box w="full">
                    <OnePDFDropzone childToParent={handleFileChange} />
                  </Box>
                </Box>
              </Flex>
            </Dialog.Body>
            {/* <Dialog.Footer>
                    <Dialog.ActionTrigger asChild>
                      <Button variant="outline" onClick={()=>{setIsOpen(false)}}>Cancel</Button>
                    </Dialog.ActionTrigger>
                    <Button>Save</Button>
                  </Dialog.Footer> */}
            <Dialog.CloseTrigger asChild>
              <CloseButton
                size="sm"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default UploadPdfModal;
